<template>
  <ion-page>
  <master-layout pageTitle="گزارشات مشتریان">
    <ion-card-content>
          <ion-grid>
            <ion-row>
              <ion-col size="12">
                <ali-ajax-select :onChange="changeCustomer"
                                 route="app/GetCustomerForSelect"
                                 title="(نام کامل - شماره تلفن بدون صفر ابتدایی)"
                                 itemTitle="fullname"
                                 name="customer_id"
                                 desc="جستجو مشتری"
                                 itemId="_id"></ali-ajax-select>
              </ion-col>
              <ion-col size="6">
                <router-link to="/Report/ProductProfit" class="btn btn-square btn-sm btn-info">
                  <i class="fa fa-car-mechanic"></i>
                  <div>سفارشات خام</div>
                  <div>
                    تعداد : <Money :number="rawOrderCount" ></Money>
                  </div>
                  <div>
                    مبلغ : <Money :number="rawOrderAmount" ></Money>
                  </div>
                </router-link>
              </ion-col>
              <ion-col size="6">
                <router-link to="/Report/ServiceProfit" class="btn btn-square btn-sm btn-success">
                  <i class="fa fa-car-mechanic"></i>
                  <div>سفارشات پرداخت شده</div>
                  <div>
                    تعداد : <Money :number="paidOrderCount" ></Money>
                  </div>
                  <div>
                    مبلغ : <Money :number="paidOrderAmount" ></Money>
                  </div>
                </router-link>
              </ion-col>
              <ion-col size="6">
                <router-link to="/Report/wastageProfit" class="btn btn-square btn-sm btn-success">
                  <i class="fa fa-money-bill-wave"></i>
                  <div>سفارشات مانده بدهی</div>
                  <div>
                    تعداد : <Money :number="debtOrderCount" ></Money>
                  </div>
                  <div>
                    مبلغ : <Money :number="debtOrderAmount" ></Money>
                  </div>
                </router-link>
              </ion-col>
              <ion-col size="6">
                <router-link to="#" class="btn btn-square btn-sm btn-info">
                  <i class="fa fa-car-mechanic"></i>
                  <div>کل سفارشات</div>
                  <div>
                    تعداد : <Money :number="totalOrderCount" ></Money>
                  </div>
                  <div>
                    مبلغ : <Money :number="totalOrderAmount" ></Money>
                  </div>
                </router-link>
              </ion-col>
              <ion-col size="6">
                <router-link to="#" class="btn btn-square btn-sm btn-info">
                  <i class="fa fa-oil-can"></i>
                  <div>حجم روغن سوخته</div>
                  <div>
                    <Money :number="used_oil" ></Money>
                  </div>
                </router-link>
              </ion-col>
              <ion-col size="6">
                <router-link to="#" class="btn btn-square btn-sm btn-info">
                  <i class="fa fa-chart-pie-alt"></i>
                  <div>درآمدکل</div>
                  <div>
                    <Money :number="totalIncome" ></Money>
                  </div>
                </router-link>
              </ion-col>
            </ion-row>
          </ion-grid>
    </ion-card-content>
  </master-layout>
  </ion-page>
</template>


<script>

import Money from '/src/components/Money'
import {
  IonCardContent, IonGrid, IonCol, IonRow,IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import AliAjaxSelect from "@/components/aliAjaxSelect";

export default {
  components: {
    IonCardContent, IonGrid, IonCol, IonRow,IonPage ,Money,AliAjaxSelect,
  },
  data(){
    return{
      rawOrderAmount: '0',
      rawOrderCount: '0',
      debtOrderAmount: '0',
      debtOrderCount: '0',
      paidOrderAmount: '0',
      paidOrderCount: '0',
      totalOrderAmount: '0',
      totalOrderCount: '0',
      totalIncome: '0',
      used_oil: '0',
    }
  },
  methods: {
    ...mapActions("app", {
      getCustomerReportItems: 'getCustomerReportItems',
    }),
    changeCustomer:async function (items)
    {
      let id = null;
      if (items && items.length)
      {
        id = items[0]._id;
      }
      if (id)
      {
        const reports = await this.getCustomerReportItems(id);
        if (reports && reports.ok)
        {
          this.rawOrderAmount = reports.items.rawOrderAmount;
          this.rawOrderCount = reports.items.rawOrderCount;
          this.debtOrderAmount = reports.items.debtOrderAmount;
          this.debtOrderCount = reports.items.debtOrderCount;
          this.paidOrderAmount = reports.items.paidOrderAmount;
          this.paidOrderCount = reports.items.paidOrderCount;
          this.totalOrderAmount = reports.items.totalOrderAmount;
          this.totalOrderCount = reports.items.totalOrderCount;
          this.totalIncome = reports.items.totalIncome;
          this.used_oil = reports.items.used_oil;
        }
      }
      else
      {
        this.rawOrderAmount = '0';
        this.rawOrderCount = '0';
        this.debtOrderAmount = '0';
        this.debtOrderCount = '0';
        this.paidOrderAmount = '0';
        this.paidOrderCount = '0';
        this.totalOrderAmount = '0';
        this.totalOrderCount = '0';
        this.totalIncome = '0';
        this.used_oil = '0';
      }

    },
  },
};
</script>

<style scoped>
.btn-square {
  width: 100%;
  display: block;
  text-align: center;
  height: 170px !important;
}
.count {
  font-size: 18px;
  font-weight: 900;
}
</style>